import React, { createContext, useContext } from 'react';

interface PriceUpFrontData {
    priceUpfrontConfiguration?: unknown;
    priceUpfrontContext?: unknown;
    isPriceUpfrontEnabled: boolean;
}

const PricingDataContext = createContext<PriceUpFrontData | undefined>(undefined);

export const usePricingDataContext = () => useContext(PricingDataContext);

export const PricingDataProvider: React.FC<{ priceUpfrontData?: PriceUpFrontData; children: React.ReactNode }> = ({
    priceUpfrontData,
    children,
}) => <PricingDataContext.Provider value={priceUpfrontData}>{children}</PricingDataContext.Provider>;
